import configuration from "@/store/modules/configuration";
import build from "@/store/modules/build";

export default {
  namespaced: true,
  state: {
    orderAmount: 1,
    notFoundProductSkus: [],
  },
  modules: {
    configuration,
    build,
  },
  getters: {
    getOrderAmount(state) {
      return state.orderAmount;
    },
    getNotFoundProductSkus(state) {
      return state.notFoundProductSkus;
    },
  },
  actions: {
    changeOrderAmount({commit}, payload) {
      commit('SET_ORDER_AMOUNT', payload)
    },
  },
  mutations: {
    SET_ORDER_AMOUNT(state, value) {
      state.orderAmount = value;
    },
    SET_NOT_FOUND_PRODUCT_SKUS(state, productSkus) {
      state.notFoundProductSkus = productSkus;
    }
  },
};
